import BlockHeader from 'shared/BlockHeader';

import TeamCheckAlt from 'assets/icons/team-check-alt.svg';
import Architer from 'assets/icons/architer.svg';
import Case from 'assets/icons/case.svg';
import Chip from 'assets/icons/chip.svg';
import PC from 'assets/icons/pc.svg';

const gap = { gap: { tablet: '10px', laptop: '20px' } };

export const telecomTechExpertData = {
  RenderTitle: (
    <>
      <BlockHeader
        fontSize={{ mobile: '28px', tablet: '32px', xxl: '64px' }}
        textsContainerProps={{ hideBelow: 'tablet', maxW: { tablet: '600px', xxl: '1000px' } }}
      >
        Программные решения и услуги для телекоммуникаций
      </BlockHeader>
      <BlockHeader
        fontSize="28px"
        textsContainerProps={{ hideBelow: 'xm', hideFrom: 'tablet', maxW: '430px' }}
      >
        Программные решения и услуги для телекоммуникаций
      </BlockHeader>
      <BlockHeader
        fontSize="28px"
        lang="ru"
        textsContainerProps={{ hideFrom: 'xm' }}
        sx={{ hyphens: 'auto', wordBreak: 'normal', overflowWrap: 'break-word' }}
      >
        Программные решения и услуги для телекоммуникаций
      </BlockHeader>
    </>
  ),

  cardsData: [
    {
      title: 'Поддержка бизнес‑процессов',
      tabIcon: Case,
      content:
        'Мы создаём программы управления связью и системами (OSS / BSS-системы) для успешного управления сетями и деятельностью компании. Решения ASTON помогают снизить издержки, обеспечить стабильность работы и сократить время вывода услуг на рынок',
      gap,
    },
    {
      title: 'Цифровые службы',
      tabIcon: Chip,
      content:
        'Наша команда создаёт облачные платформы и цифровые продукты для извлечения прибыли из потока данных и новых услуг. Помогаем операторам выстраивать единую среду услуг и сохранять лояльность пользователей благодаря передовым разработкам',
      gap,
    },
    {
      title: 'Пользовательский опыт',
      tabIcon: TeamCheckAlt,
      content:
        'Мы проектируем приложения, клиентские порталы, системы самообслуживания и виртуальных собеседников (чат‑боты). Решения ASTON позволяют подстраиваться под нужды каждого и повышать преданность абонентов',
      gap,
    },
    {
      title: 'Управление предприятием',
      tabIcon: Architer,
      content:
        'Мы внедряем системы управления ресурсами (ERP), электронный документооборот, программы для работы с кадрами и зарплатой, единые справочники (НСИ), планирование расходов и закупки. Наши решения помогают телекоммуникационным компаниям налаживать повседневную работу и управлять сложными процессами',
      gap,
    },
    {
      title: 'Сопровождение ИТ‑решений',
      tabIcon: PC,
      content:
        'ASTON обеспечивает полную поддержку информационных технологий: от планирования и проектирования систем до разработки, переноса данных, проверки качества, согласованной работы разработчиков и служб эксплуатации (DevOps), а также внедрения искусственного интеллекта и интернета вещей (IoT). Мы гарантируем возможность роста систем и готовность к будущим задачам',
      gap,
    },
  ],
};
